export enum SOP_TABS {
  ORDER_RENEWAL = "ORDER_RENEWAL",
  PV_THIS_MONTH = "PV_THIS_MONTH",
  NO_PV_THIS_MONTH = "NO_PV_THIS_MONTH",
}
